<template>
  <md-dialog 
    :md-active.sync="showDialog" 
    class="new-fluid-dialog new-globals"
    @md-clicked-outside="clickOutside"
  >
    <md-dialog-content>
      <label>Add New Fluid</label>
      <md-field 
        class="new-fluid ui-theme-3 compact"
      >
        <md-input 
          :value="state.name"
          placeholder="Enter a name"
          aria-label="New Fluid Name"
          data-testid="new-fluid-name-input"
          @input="updateName"
        />
      </md-field>
      <md-divider class="divider" />
      <label>Add New Volume</label>
      <md-field class="ui-theme-3 dosage-form compact">
        <md-select
          :value="state.bagVolumes"
          multiple
          aria-label="Add New Volume"
          data-testid="volume-select"
          @input="updateBagVolumes"
        >
          <md-option
            v-for="bv in infusionBagVolumes"
            :key="bv.key"
            :value="bv.key"
            :aria-label="bv.label.en"
            data-testid="volume-option"
          >
            {{ bv.label.en }}
          </md-option>
        </md-select>
      </md-field>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button 
        class="cancel-button"
        aria-label="Cancel"
        data-testid="cancel-button"
        @click="cancel"
      >
        Cancel
      </md-button>
      <md-button 
        class="md-outlined-button submit-button" 
        :disabled="!hasCompleteInput"
        aria-label="Submit"
        data-testid="submit-button"
        @click="submit"
      >
        Submit
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { infusionBagVolumes } from '~lib/common/config/medication';

export default {
  name: 'new-med-dialog',
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDialog: false,
      state: {
        name: null,
        bagVolumes: [],
      },
      infusionBagVolumes,
    };
  },
  computed: {
    hasCompleteInput() {
      let hasComplete = true;
      if (!this.state.name) {
        hasComplete = false;
      }
      return hasComplete;
    },
  },
  watch: {
    show(value) {
      this.showDialog = value;
    }
  },
  created() {
    this.reset();
  },
  methods: {
    updateName(value) {
      this.state.name = value;
    },
    updateBagVolumes(values) {
      this.state.bagVolumes = values;
    },
    cancel() {
      this.state.showDialog = false;
      this.$emit('cancel');
      this.reset();
    },
    submit() {
      this.state.showDialog = false;
      this.$emit('submit', {
        name: this.state.name,
        bagVolumes: this.state.bagVolumes,
      });
      this.reset();
    },
    clickOutside() {
      this.cancel();
    },
    reset() {
      this.state.name = 'New Fluid';
      this.state.bagVolumes = [];
    },
  }
}
</script>

<style scoped>
.new-fluid-dialog {
  height: auto;
  min-width: 500px;
}

.md-field.compact {
  margin: 0 !important;
  margin-top: 12px !important;
  padding-top: 6px !important;
  padding-bottom: 0 !important;
  min-height: 40px;
}

.divider {
  margin: 1rem 0;
}

.submit-button {
  color: white;
  background-color: #3277CC;
}
</style>